<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

export interface DialogHeaderProps {
	class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<DialogHeaderProps>(), {
	class: ''
});
</script>

<template>
	<div
		:class="
			cn(
				'flex items-center justify-between gap-y-1.5 border-b border-white-dark-3 bg-white p-5',
				props.class
			)
		"
	>
		<slot></slot>
	</div>
</template>
